import { ReactNode } from "react";

import DateFnsUtils from "@date-io/date-fns";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { ptBR } from "date-fns/locale";
import { Grid } from "@material-ui/core";
import moment from "moment";
type DatePickerView = 'year' | 'date' | 'month'
export interface InputDateMonthYearProperties {
  id?: string;
  name?: string;
  label: string;
  placeholder?: string;
  variant?: "dialog" | "static" | "inline";
  inputVariant?: "filled" | "outlined" | "standard";
  format?: string;
  value?: any;
  defaultValue?: string;
  pattern?: string;
  size?: "small" | "medium";
  fullWidth: boolean;
  error?: boolean;
  readonly?: boolean;
  margin?: "normal" | "dense";
  prefix?: ReactNode;
  openTo?: "date" | "month" | "year"
  onKeyPress?: Function;
  onKeyUp?: Function;
  onKeyDown?: Function;
  onBlur?: Function;
  onFocus?: Function;
  onChange?: (date: string | null) => void,
  disabled?: boolean;
  minDate?: Date;
  maxDate?: Date;
  views?: DatePickerView[];
}

const DEFAULT_PARAMENTERS: InputDateMonthYearProperties = {
  label: "",
  variant: "dialog",
  value: null,
  inputVariant: "outlined",
  size: "small",
  fullWidth: true,
  error: false,
  margin: "normal",
  format: "MMMM/yyyy",
  openTo: "year",
  views: ["year", "month"]
}

const InputDateMonthYear = (props: InputDateMonthYearProperties) => {
  props = { ...DEFAULT_PARAMENTERS, ...props };

  const handleDateChange = (date: Date | null) => {
    if (props.onChange) {
      if (date === null) {
        props.onChange(null);
      } else {
        props.onChange(moment(date).format("YYYY-MM-DD HH:mm:ss"));
      }
    }
  }

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBR}>
      <Grid container justifyContent="space-around">
        <DatePicker

          inputVariant={props.inputVariant}
          fullWidth={props.fullWidth}
          size={props.size}
          disableToolbar
          variant={props.variant}
          format={props.format}
          name={props.name}
          disabled={props.disabled}
          margin="normal"
          id={props.id || btoa(new Date().getMilliseconds().toString())}
          InputLabelProps={{ shrink: true }}
          InputProps={{
            fullWidth: props.fullWidth,
            startAdornment: props.prefix
          }}
          views={props.views}
          label={props.label}
          value={props.value}
          onChange={handleDateChange}
          minDate={props.minDate}
          maxDate={props.maxDate}
          openTo={props.openTo}
          placeholder={props.placeholder}
          error={props?.error}
          onBlur={(event: any) => {
            if (props?.onBlur) {
              props.onBlur(event)
            }
          }}
        />
      </Grid>
    </MuiPickersUtilsProvider >
  );
};

export { InputDateMonthYear };
